<template>
  <div class="cyryDialog" >
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="从业人员基本信息"
      :visible="dialogFormVisible"
      center
      @close="closeDialog"
    >
      <div v-loading="loading" class="leftcyry">
        <div v-for="(item, i) in cardImg" :key="i" class="card_img_item">
          <el-upload
            :disabled="cyrytype"
            class="upload-demo"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
            :on-error="onError"
            :show-file-list="false"
            :headers="token"
          >
            <el-image
              v-loading="item.loading"
              v-preventReClick
              :src="item.img"
              :fit="item.name"
              @click.native="typefz(item.type)"
            />
            <p>{{ item.name }}</p>
          </el-upload>
          <div
            v-show="item.closeBox"
            v-preventReClick
            class="deleteUpload"
            @click="removeCurImg(item.type)"
          >
            <i class="el-icon-circle-close" />
          </div>
        </div>
      </div>
      <div v-loading="loading" class="rightcyry">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="姓名:"
            prop="xm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.xm"
              :disabled="cyrytype"
              placeholder="请输入姓名"
            />
          </el-form-item>
          <el-form-item label="性别:" prop="xb">
            <el-select
              v-model="form.xb"
              placeholder="请选择性别"
              :disabled="isAdd"
            >
              <el-option
                v-for="item in sys_user_sex"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="民族:">
            <el-select
              v-model="form.mz"
              placeholder="请选择民族"
              :disabled="cyrytype"
            >
              <el-option
                v-for="item in yzd_mz"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="证件类型:" prop="zjlx">
            <el-select
              v-model="form.zjlx"
              placeholder="请选择"
              :disabled="isAdd"
              @change="zjlxchange"
            >
              <el-option
                v-for="item in yzd_zjlx"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="!zjlxtype" label="证件名称:" prop="qtzj">
            <el-select
              v-model="form.qtzj"
              placeholder="请选择"
              :disabled="isAdd"
            >
              <el-option
                v-for="item in yzd_ry_zjmc"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="证件号码:"
            prop="zjhm"
            class="zjhm"
            :class="{ elForm: zjlxtype }"
          >
            <el-input
              v-model="form.zjhm"
              :disabled="isAdd"
              placeholder="请输入证件号码"
            />
          </el-form-item>

          <el-form-item prop="sr" label="生日:">
            <el-date-picker
              v-model="form.sr"
              :disabled="cyrytype"
              type="date"
              placeholder="选择日期"
              :picker-options="this.startTime()"
            />
          </el-form-item>

          <!-- v-if="!zjlxtype" -->
          <el-form-item label="有效期:" required class="yxqzj" prop="yxqzj">
            <el-col :span="11.5">
              <el-form-item prop="yxqxKs">
                <el-date-picker
                  v-model="form.yxqxKs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="this.startTime(form.yxqxJs)"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="margin: 0 20px; text-align: center; width: 14px"
            >
              <span>至</span>
            </el-col>
            <el-col :span="11.5">
              <el-form-item prop="yxqxJs">
                <el-date-picker
                  v-model="form.yxqxJs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="this.endTime(form.yxqxKs)"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <!--  v-if="!zjlxtype"  发证机关 会一直有 文静:改2022/1/18-->
          <el-form-item
            label="发证机关:"
            prop="fzjg"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 155);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.fzjg"
              placeholder="请输入发证机关"
              :disabled="cyrytype"
            />
          </el-form-item>
          <el-form-item label="岗位:" prop="gw">
            <el-select
              v-model="zwList"
              multiple
              placeholder="请选择岗位"
              :disabled="cyrytype"
              @change="gwchange"
            >
              <el-option
                v-for="item in yzd_cyry_zw"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="聘用时间:" prop="pysj">
            <el-date-picker
              v-model="form.pysj"
              :disabled="cyrytype"
              type="date"
              placeholder="请选择时间"
            />
          </el-form-item>

          <el-form-item
            v-if="zwtype"
            label="驾驶员驾驶证号:"
            label-width="130px"
            prop="jszZjhm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 100);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.jszZjhm"
              :disabled="cyrytype"
              placeholder="请输入驾驶证号"
            />
          </el-form-item>
          <el-form-item
            v-if="zwtype"
            label="驾驶员准驾车型:"
            prop="jszZjcx"
            label-width="130px"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.jszZjcx"
              :disabled="cyrytype"
              placeholder="请输入准驾车型"
            />
          </el-form-item>
          <el-form-item
            v-if="zwtype"
            label="驾驶员证件有效期:"
            label-width="139px"
            required
            class="yxq"
          >
            <el-col :span="11.5">
              <el-form-item prop="jszYxqKs">
                <el-date-picker
                  v-model="form.jszYxqKs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="this.startTime(form.jszYxqJs)"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="margin: 0 20px; text-align: center; width: 14px"
            >
              <span>至</span>
            </el-col>
            <el-col :span="11.5">
              <el-form-item prop="jszYxqJs">
                <el-date-picker
                  v-model="form.jszYxqJs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="this.endTime(form.jszYxqKs)"
                />
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item
            v-if="zwtype"
            label="驾驶员证件发证机关:"
            prop="jszFzjg"
            label-width="155px"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 255);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.jszFzjg"
              placeholder="请输入发证机关"
              :disabled="cyrytype"
            />
          </el-form-item>

          <el-form-item
            v-if="zwtype1"
            label="押运证号:"
            prop="yyzZjhm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 100);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.yyzZjhm"
              placeholder="请输入押运证号"
              :disabled="cyrytype"
            />
          </el-form-item>
          <el-form-item
            v-if="zwtype1"
            label="押运员证件有效期:"
            label-width="139px"
            required
            class="yxq"
          >
            <el-col :span="11.5">
              <el-form-item prop="yyzYxqKs">
                <el-date-picker
                  v-model="form.yyzYxqKs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="this.startTime(form.yyzYxqJs)"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="margin: 0 20px; text-align: center; width: 14px"
            >
              <span>至</span>
            </el-col>
            <el-col :span="11.5">
              <el-form-item prop="yyzYxqJs">
                <el-date-picker
                  v-model="form.yyzYxqJs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="this.endTime(form.yyzYxqKs)"
                />
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item
            v-if="zwtype1"
            label="押运员证件发证机关:"
            prop="yyzFzjg"
            label-width="155px"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 255);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.yyzFzjg"
              placeholder="请输入发证机关"
              :disabled="cyrytype"
            />
          </el-form-item>

          <el-form-item label="手机号码:" prop="sjhm">
            <el-input
              v-model="form.sjhm"
              :disabled="cyrytype || cyrylxsjhdisabled"
              placeholder="请输入手机号码"
            />
          </el-form-item>

          <el-form-item
            label="办公电话:"
            prop="bgdh"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 50);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bgdh"
              :disabled="cyrytype"
              placeholder="请输入办公电话"
            />
          </el-form-item>
          <el-form-item label="籍贯:">
            <el-input v-if="cyrytype"
              v-model="form.jgLabel == null?'':form.jgLabel.replaceAll(',',' / ')" disabled
            />
            <el-cascader v-else
              v-model="jgList"
              clearable
              placeholder="请选择籍贯"
              :props="props"
              filterable
              @change="jgchange"
            />
          </el-form-item>

          <el-form-item
            label="实际住址:"
            class="sjzz"
            prop="sjzz"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 600);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.sjzz"
              :disabled="cyrytype"
              placeholder="请输入实际住址"
            />
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="loading" v-if="cyrytype && form.splcDtos.length" class="_title">
        <p class="_title_info">审批结果</p>
      </div>
      <div
        v-for="(item, index) in form.splcDtos"
        v-loading="loading"
        :key="index"
        style="margin-bottom: 30px; width: 100%"
      >
        <el-timeline>
          <el-timeline-item v-if="item[0]" icon="el-icon-time" size="large">
            <div style="margin-top: 2px">
              <span style="font-weight: bold"> 申请时间： </span>
              <span>{{ item[0].clsj }}</span>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-for="(arr, key) in item"
            :key="key"
            :icon="key == item.length - 1 ? 'el-icon-success' : ''"
            :type="arr.type"
            :size="key == item.length - 1 ? 'large' : arr.size"
            :color="arr.color"
          >
            <div style="display: flex">
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批单位：</span>{{ arr.dqbmLabel }}
              </div>
              <div v-if="arr.sftyLabel !== '待审批'" style="margin-right: 20px">
                <span style="font-weight: bold">{{ arr.jsLabel }}人：</span>{{ arr.sjsprLabel }}
              </div>
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批结果：</span><span
                  :style="
                    arr.sftyLabel == '同意'
                      ? 'color: #00ceb7'
                      : arr.sftyLabel == '不同意'
                        ? 'color: red'
                        : 'color: Orange'
                  "
                >{{ arr.sftyLabel }}</span>
              </div>
              <div v-if="arr.sftyLabel !== '待审批'" style="margin-right: 20px">
                <span style="font-weight: bold">审批时间：</span>{{ arr.spsj }}
              </div>
            </div>
            <div v-if="arr.sftyLabel !== '待审批'" style="margin-top: 2px">
              <span style="font-weight: bold">审批意见：</span><span>{{ arr.spyj }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div slot="footer" v-loading="loading" class="dialog-footer">
        <el-button
          v-if="!this.cyrytype"
          v-preventReClick
          @click="closeDialog()"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; margin-left: 50px"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import {
  url1,
  returnSaveFile,
  returnShowPic,
  getToken,
  getkv,
  addcyryMes
} from '@/assets/js/common.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'
import { startTime, endTime } from '@/assets/js/validate.js'
export default {
  name: 'CyryDialog',
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: {}
    },
    cyrytype: {
      type: Boolean,
      default: {}
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validateCard = (rule, value, callback) => {
      if (this.form.zjlx == '1') {
        if (!value) {
          return callback(new Error('请输入证件号码'))
        } else {
          if (!this.IdentityCodeValid(value)) {
            return callback(new Error('请输入正确的身份证号码'))
          } else {
            return callback()
          }
        }
      } else {
        lengthValidate(rule, value, callback, 'bt', 100)
      }
      callback()
    }
    return {
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 200)
        }
      },
      token: {
        Authorization: getToken()
      },
      loading: false,
      cardType: 0, // 图片为正面，反面或其他
      returnSaveFile: '', // 保存图片
      returnShowPic: '', // 回显图片
      URL1: '',
      cardImglist: [
        {
          name: '证件人像面（500KB以内）',
          type: 1,
          img: require('../assets/img/zjrlx.png'),
          imgbf: require('../assets/img/zjrlx.png'),
          closeBox: false,
          formname: 'zjzpZm'
          // loading: true,
        },
        {
          name: '证件国徽面（500KB以内）',
          type: 2,
          img: require('../assets/img/zjghx.png'),
          imgbf: require('../assets/img/zjghx.png'),
          closeBox: false,
          formname: 'zjzpFm'
          // loading: true,
        },
        {
          name: '驾驶证（500KB以内）',
          type: 3,
          img: require('../assets/img/zjrlx.png'),
          imgbf: require('../assets/img/zjrlx.png'),
          closeBox: false,
          formname: 'jszZjurl'
          // loading: true,
        },
        {
          name: '押运证（500KB以内）',
          type: 4,
          img: require('../assets/img/zjrlx.png'),
          imgbf: require('../assets/img/zjrlx.png'),
          closeBox: false,
          formname: 'yyzZjurl'
          // loading: true,
        }
      ],
      fileList: [],
      form: {
        xm: '', // 姓名
        xb: '', // 性别
        zjhm: '', // 证件号码
        zjlx: '', // 证件类型
        sr: '',
        qtzj: '', // 证件名称
        yxqxKs: '',
        yxqxJs: '',
        fzjg: '',
        mz: '', // 民族
        gw: '', // 岗位
        pysj: '', // 聘用时间
        sjhm: '', // 手机号码
        bgdh: '', // 办公电话
        jg: '', // 籍贯
        jgLabel: '', // 籍贯
        sjzz: '', // 实际住址
        zjzpZm: '',
        zjzpFm: '',
        jszZjurl: '',
        yyzZjurl: '',
        jszZjhm: '', // 驾驶证号
        jszZjcx: '', // 准驾车型
        jszYxqKs: '', // 有效期
        jszYxqJs: '', // 有效期
        jszFzjg: '', // 发证机关
        yyzZjhm: '',
        yyzYxqKs: '',
        yyzYxqJs: '',
        yyzFzjg: '',
        splcDtos: []
      },
      rules: {
        // xm: [
        //   {
        //     required: true,
        //     message: "请输入姓名",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        xb: [
          {
            required: true,
            message: '请选择性别',
            trigger: ['blur', 'change']
          }
        ],
        zjhm: [
          {
            required: true,
            validator: validateCard,
            trigger: ['blur', 'change']
          }
        ],
        sr: [
          {
            required: true,
            message: '请输入',
            trigger: ['blur', 'change']
          }
        ],
        zjlx: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        qtzj: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        // fzjg: [
        //   { required: true, message: "请输入", trigger: ["blur", "change"] },
        // ],
        yxqxKs: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        yxqxJs: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        gw: [
          {
            required: true,
            message: '请选择岗位',
            trigger: ['blur', 'change']
          }
        ],
        pysj: [
          {
            required: true,
            message: '请输入聘用时间',
            trigger: ['blur', 'change']
          }
        ],
        // jszZjhm: [
        //   {
        //     required: true,
        //     message: "请输入驾驶证号",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // jszZjcx: [
        //   {
        //     required: true,
        //     message: "请输入准驾车型",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        jszYxqKs: [
          {
            required: true,
            message: '请选择时间',
            trigger: ['blur', 'change']
          }
        ],
        jszYxqJs: [
          {
            required: true,
            message: '请选择时间',
            trigger: ['blur', 'change']
          }
        ],
        // jszFzjg: [
        //   {
        //     required: true,
        //     message: "请输入发证机关",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // yyzZjhm: [
        //   { required: true, message: "请输入", trigger: ["blur", "change"] },
        // ],
        yyzYxqKs: [
          {
            required: true,
            message: '请选择时间',
            trigger: ['blur', 'change']
          }
        ],
        yyzYxqJs: [
          {
            required: true,
            message: '请选择时间',
            trigger: ['blur', 'change']
          }
        ],
        // yyzFzjg: [
        //   {
        //     required: true,
        //     message: "请输入发证机关",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        sjhm: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const mobile = /^1[3456789]\d{9}$/
              if (!value) {
                return callback(new Error('手机号不能为空！'))
              }
              if (!mobile.test(value)) {
                return callback(new Error('手机号格式错误！'))
              }
              callback()
            }
          }
        ]
        // sjzz: [
        //   {
        //     required: true,
        //     message: "请输入实际住址",
        //     trigger: ["blur", "change"],
        //   },
        // ],
      },
      yzd_zjlx: [], // 证件类型
      yzd_ry_zjmc: [], // 其他证件
      yzd_mz: [], // 民族
      yzd_cyry_zw: [], // 岗位
      sys_user_sex: [], // 性别
      id: '',
      cyrylxsjh: '',
      zwList: [],
      jgList: []
    }
  },
  computed: {
    cyrylxsjhdisabled() {
      if (this.cyrylxsjh == '01' || this.cyrylxsjh == '04') return true
      else return false
    },
    zwtype() {
      if (this.form.gw.includes('2')) return true
      else return false
    },
    zwtype1() {
      if (this.form.gw.includes('1')) return true
      else return false
    },
    zjlxtype() {
      if (this.form.zjlx == '1' || this.form.zjlx == '') return true
      else return false
    },
    cardImg: {
      // zjlxtype证件类型 身份证true zwtype驾驶员  zwtype1押运员
      get() {
        if (this.zwtype && this.zwtype1 && this.zjlxtype) {
          return this.cardImglist
        } else if (this.zwtype && this.zwtype1 && !this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 1),
            ...this.cardImglist.slice(2)
          ]
        } else if (this.zwtype && !this.zwtype1 && this.zjlxtype) {
          return this.cardImglist.slice(0, 3)
        } else if (this.zwtype && !this.zwtype1 && !this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 1),
            ...this.cardImglist.slice(2, 3)
          ]
        } else if (!this.zwtype && this.zwtype1 && this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 2),
            ...this.cardImglist.slice(3)
          ]
        } else if (!this.zwtype && this.zwtype1 && !this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 1),
            ...this.cardImglist.slice(3)
          ]
        } else if (!this.zwtype && !this.zwtype1 && this.zjlxtype) {
          return this.cardImglist.slice(0, 2)
        } else if (!this.zwtype && !this.zwtype1 && !this.zjlxtype) {
          return this.cardImglist.slice(0, 1)
        }
      },
      set(val) {
        return val
      }
    }
  },
  watch: {
    'form.jg': {
      deep: true,
      handler(val, oldVal) {
        if (this.form.jg) {
          this.jgList = this.form.jg.split(',').map(Number)
        }
      }
    }
  },
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    getkv('yzd_zjlx').then((e) => {
      this.yzd_zjlx = e.data.data
    })
    getkv('yzd_ry_zjmc').then((e) => {
      this.yzd_ry_zjmc = e.data.data
    })
    getkv('yzd_mz').then((e) => {
      this.yzd_mz = e.data.data
    })
    getkv('yzd_cyry_gw').then((e) => {
      this.yzd_cyry_zw = e.data.data
    })

    this.sys_user_sex = [
      {
        value: '0',
        label: '男'
      },
      {
        value: '1',
        label: '女'
      },
      {
        value: '2',
        label: '未知'
      }
    ]
  },
  mounted() {
    this.$nextTick(() => {})
  },
  methods: {
    startTime,
    endTime,
    lengthValidate,
    IdentityCodeValid(code) {
      // 验证身份证合法性
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
      }
      var pass = true

      var patt1 = new RegExp(
        '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)'
      )
      if (!code || !patt1.test(code)) {
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          if (parity[sum % 11] != code[17]) {
            pass = false
          }
        }
      }
      return pass
    },
    // 初始化表单内容
    getformMes(dataMes) {
      this.id = dataMes.id
      this.cyrylxsjh = dataMes.cyrylx
      this.$nextTick(() => {
        this.form = Object.assign(
          {},
          {
            sr: dataMes.sr,
            xm: dataMes.xm, // 姓名
            xb: dataMes.xb, // 性别
            zjhm: dataMes.zjhm, // 证件号码
            zjlx: dataMes.zjlx, // 证件类型
            qtzj: dataMes.qtzj, // 证件名称
            yxqxKs: dataMes.yxqxKs,
            yxqxJs: dataMes.yxqxJs,
            fzjg: dataMes.fzjg,
            mz: dataMes.mz, // 民族
            gw: dataMes.gw, // 岗位
            pysj: dataMes.pysj, // 聘用时间
            jszZjhm: dataMes.jszZjhm, // 驾驶证号
            jszZjcx: dataMes.jszZjcx, // 准驾车型
            jszYxqKs: dataMes.jszYxqKs, // 有效期
            jszYxqJs: dataMes.jszYxqJs, // 有效期
            jszFzjg: dataMes.jszFzjg, // 发证机关
            yyzZjhm: dataMes.yyzZjhm,
            yyzYxqKs: dataMes.yyzYxqKs,
            yyzYxqJs: dataMes.yyzYxqJs,
            yyzFzjg: dataMes.yyzFzjg,
            sjhm: dataMes.sjhm, // 手机号码
            bgdh: dataMes.bgdh, // 办公电话
            jg: dataMes.jg, // 籍贯
            jgLabel: dataMes.jgLabel, // 籍贯
            sjzz: dataMes.sjzz, // 实际住址
            zjzpZm: dataMes.zjzpZm,
            zjzpFm: dataMes.zjzpFm,
            jszZjurl: dataMes.jszZjurl,
            yyzZjurl: dataMes.yyzZjurl,
            splcDtos: dataMes.splcDtos
          }
        )
        if (dataMes.gw) this.zwList = dataMes.gw.split(',')
        if (dataMes.jg) this.jgList = dataMes.jg.split(',').map(Number)

        this.cardImg.forEach((item) => {
          if (item.type == 1 && dataMes.zjzpZm != '' && dataMes.zjzpZm != null) { item.img = this.returnShowPic + dataMes.zjzpZm } else if (
            item.type == 2 &&
            dataMes.zjzpFm != '' &&
            dataMes.zjzpFm != null
          ) { item.img = this.returnShowPic + dataMes.zjzpFm } else if (
            item.type == 3 &&
            dataMes.jszZjurl != '' &&
            dataMes.jszZjurl != null
          ) { item.img = this.returnShowPic + dataMes.jszZjurl } else if (
            item.type == 4 &&
            dataMes.yyzZjurl != '' &&
            dataMes.yyzZjurl != null
          ) { item.img = this.returnShowPic + dataMes.yyzZjurl }

          this.fileList.push({
            url: item.img
          })
          item.loading = false
        })
      })
    },
    addcyryMess(dataObj) {
      this.loading = true
      addcyryMes(dataObj).then((e) => {
        this.loading = false
        if (e.data.mesg == '该证件号已存在!') return false
        this.$message.success('保存成功')
        this.reset()
        this.$parent.search()
      }).catch((error) => {
        this.loading = false
      })
    },
    reset() {
      this.$nextTick(() => {})
      this.$refs['form'].resetFields()
      this.$emit('close-dialog')
      this.fileList = []
      this.form.zjzpZm = ''
      this.form.zjzpFm = ''
      this.form.jszZjurl = ''
      this.form.yyzZjurl = ''
      this.id = ''
    },
    zjImageJC() {
      var mes = []
      this.cardImg.forEach((item) => {
        if (
          item.type == 1 &&
          (this.form.zjzpZm == '' || this.form.zjzpZm == null)
        ) { mes.push('请上传证件人像面') } else if (
          item.type == 2 &&
          (this.form.zjzpFm == '' || this.form.zjzpFm == null)
        ) { mes.push('请上传证件国徽面') } else if (
          item.type == 3 &&
          (this.form.jszZjurl == '' || this.form.jszZjurl == null)
        ) { mes.push('请上传驾驶证') } else if (
          item.type == 4 &&
          (this.form.yyzZjurl == '' || this.form.yyzZjurl == null)
        ) { mes.push('请上传押运证') }
      })
      return mes
    },
    gwchange(val) {
      if (this.form.gw.includes('2') && !val.join(',').includes('2')) {
        this.form.jszZjhm = ''
        this.form.jszZjcx = ''
        this.form.jszFzjg = ''
        this.form.jszYxqKs = ''
        this.form.jszYxqJs = ''
        var res = this.cardImg.filter((item) => {
          return item.type == 3
        })
        res[0].img = res[0].imgbf
        res[0].closeBox = false
        this.form[res[0].formname] = ''
      }
      if (this.form.gw.includes('1') && !val.join(',').includes('1')) {
        this.form.yyzZjhm = ''
        this.form.yyzFzjg = ''
        this.form.yyzYxqKs = ''
        this.form.yyzYxqJs = ''
        this.form.yyzZjurl = ''
        var res = this.cardImg.filter((item) => {
          return item.type == 4
        })
        res[0].img = res[0].imgbf
        res[0].closeBox = false
        this.form[res[0].formname] = ''
      }
      this.form.gw = val.join(',')
    },
    zjlxchange(val) {
      this.form.qtzj = ''
      this.form.zjhm = ''
      this.form.yxqxKs = ''
      this.form.yxqxJs = ''
      this.form.fzjg = ''
    },
    jgchange(val) {
      this.form.jg = val.join(',')
    },
    submitForm(formName) {
      if (this.cyrytype) {
        this.reset()
        return
      }
      var mes = this.zjImageJC()
      this.$set(this.form, 'yxqzj', '占位符')
      this.$refs[formName].validate((valid, obj) => {
        if (valid && mes.length == 0) {
          // 验证通过后重置表单关闭弹窗
          this.form = {
            sr: this.form.sr,
            id: this.id,
            xm: this.form.xm, // 姓名
            xb: this.form.xb, // 性别
            zjhm: this.form.zjhm, // 证件号码
            zjlx: this.form.zjlx, // 证件类型
            qtzj: this.form.qtzj, // 证件名称
            yxqxKs: this.form.yxqxKs,
            yxqxJs: this.form.yxqxJs,
            fzjg: this.form.fzjg,
            mz: this.form.mz, // 民族
            gw: this.form.gw, // 岗位
            pysj: this.form.pysj, // 聘用时间
            jszZjhm: this.form.jszZjhm, // 驾驶证号
            jszZjcx: this.form.jszZjcx, // 准驾车型
            jszYxqKs: this.form.jszYxqKs, // 有效期
            jszYxqJs: this.form.jszYxqJs, // 有效期
            jszFzjg: this.form.jszFzjg, // 发证机关
            yyzZjhm: this.form.yyzZjhm,
            yyzYxqKs: this.form.yyzYxqKs,
            yyzYxqJs: this.form.yyzYxqJs,
            yyzFzjg: this.form.yyzFzjg,
            sjhm: this.form.sjhm, // 手机号码
            bgdh: this.form.bgdh, // 办公电话
            jg: this.form.jg ? this.form.jg.toString() : '', // 籍贯
            sjzz: this.form.sjzz, // 实际住址
            zjzpZm: this.form.zjzpZm,
            zjzpFm: this.form.zjzpFm,
            jszZjurl: this.form.jszZjurl,
            yyzZjurl: this.form.yyzZjurl
          }
          this.addcyryMess(this.form)
        } else {
          if (mes.length > 0) {
            this.$message.error(mes.toString())
          }
          return false
        }
      })
    },
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    typefz(type) {
      this.cardType = type
    },
    // 成功
    handleAvatarSuccess(response, file, fileList) {
      this.fileList = fileList
      const data = response.data

      // if (data.oneData) {
      //   // for (let key in data.oneData) {
      //   //   if (data.oneData[key] != null) {
      //   //     this.form[key] = data.oneData[key];
      //   //   }
      //   // }
      //   this.$message.success("证件上传成功!");
      // } else {
      //   if (this.cardType == 1 || this.cardType == 2)
      //     this.$message.warning("证件上传成功,但无法识别!请手动填写!");
      //   else this.$message.success("证件上传成功!");
      // }
      var res = this.cardImg.filter((item) => {
        return item.type == this.cardType
      })
      res[0].img = this.returnShowPic + data.url
      res[0].closeBox = true
      res[0].loading = false
      this.form[res[0].formname] = data.url
    },
    removeCurImg(type) {
      var res = this.cardImg.filter((item) => {
        return item.type == type
      })
      res[0].img = res[0].imgbf
      res[0].closeBox = false
      this.form[res[0].formname] = ''
    },
    onError() {
      this.$message.error('证件上传失败!')
    },
    // 文件列表移除文件时
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    // 文件改变时
    handleprogress(file, fileList) {
      this.fileList = fileList
      // if (this.cardType == 1) {
      //   this.cardImg[0].loading = true;
      // }
      // if (this.cardType == 2) {
      //   this.cardImg[1].loading = true;
      // }
      // if (this.cardType == 3) {
      //   this.cardImg[2].loading = true;
      // }
    },
    // 点击文件列表中已上传的文件，预览
    handlePictureCardPreview(file) {
      //   this.dialogImageUrl = file.url;
      //   this.dialogVisible = true;
    },
    // 文件超出个数限制时
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    closeDialog() {
      this.reset()
    }
  }
}
</script>

<style lang="less" scoped>
.cyryDialog {
  /deep/ .el-dialog {
    width: 1084px;
    margin-top: 5vh !important;

    .el-dialog__header {
      width: 100%;
      padding: 0;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      .el-dialog__title {
        display: block;
        padding: 52px 0;
        height: 28px;
        line-height: 0;
      }
    }
    .el-dialog__body {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 !important;

      .leftcyry {
        width: 179.35px;
        margin-left: 85px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /deep/ .el-upload--picture-card {
          width: 179.35px;
        }
        .card_img_item {
          position: relative;
          .el-image {
            width: 179.35px !important;
            height: 110px !important;
          }
          p {
            margin: 11px 0 40px 0;
          }
          .deleteUpload {
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
      .rightcyry {
        width: 667px;
        margin-right: 85px; // 144px;
        .el-form {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          & > .el-form-item {
            // display: flex;
            width: 48%;
            // width: 280px;
            margin-bottom: 20px;
            margin-right: 0;

            .el-form-item__label {
              // width: 85px;
              width: 96px;
              color: #333333;
            }
            .el-form-item__content {
              display: flex;

              .el-date-editor.el-input,
              .el-date-editor.el-input__inner {
                width: 100%;
              }
              .el-cascader,
              .el-select {
                width: 100%;
              }
            }
          }

          & > .yxq {
            width: 100%;
            height: 39px;
            & > .el-form-item__content {
              width: calc(100% - 139px) !important;
            }
            [class*="el-col-11.5"] {
              width: 100%;
              & > .el-form-item {
                margin-right: 0;
                & > .el-form-item__content {
                  margin-right: 0;
                }
              }
            }
          }
          & > .yxqzj {
            width: 100%;
            height: 39px;
            & > .el-form-item__content {
              width: calc(100% - 96px) !important;
            }
            [class*="el-col-11.5"] {
              width: 100%;
              & > .el-form-item {
                margin-right: 0;
                & > .el-form-item__content {
                  margin-right: 0;
                }
              }
            }
          }

          .zjhm {
            width: 48%;
            .el-form-item__content {
              width: calc(100% - 96px) !important;
            }
          }
          .sjzz {
            width: 100%;
            .el-form-item__content {
              width: calc(100% - 96px) !important;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      width: 100%;
      padding-bottom: 50px;
    }
  }
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
}
/deep/.elForm {
  width: 100% !important;
}
/deep/.el-timeline-item__icon {
  font-size: 16px !important;
  color: #fff;
  background-color: #ef9a12;
  border-radius: 50%;
}

/deep/.el-icon-success {
  color: #6acd18;
  background-color: #fff;
}
</style>

